import { ProjectFormWrapper } from '../../project/models/project-form-wrapper.model';

export class BoardAgendaFormSummary {
    public count: number;
    public data: [string, any];
    public forms: ProjectFormWrapper[];
    public formType: string;
    public legislation: string;
}
